import { useState } from 'react';

import { Result } from '../../../../../../shared/helpers/Result';
import { ComponentData } from '../../../../../../shared/types';

type Models = {
  isSaving: boolean;
};

type Operations = {
  submit: () => Promise<void>;
};

type Props = {
  isOpen: boolean;
  onClose: () => void;
  bookAsn: () => Promise<Result>;
};

export function useBookingModalComponent({
  onClose,
  bookAsn,
}: Props): ComponentData<Models, Operations> {
  const [isSaving, setIsSaving] = useState(false);

  const submit = async () => {
    setIsSaving(true);
    const result = await bookAsn();
    setIsSaving(false);
    if (result.isSuccess) onClose();
  };

  return {
    models: { isSaving },
    operations: { submit },
  };
}
